module.exports = __webpack_public_path__ + "static/img/pay-pc-success1.3df3090a.png";